import React, { Component } from "react";
import Form from "react-jsonschema-form-bs4";
import {
  schema as GeyserSchema,
  uiSchema as GeyseruiSchema
} from "wn-claims-shared/dist/schema/geyser-schema";
import {
  schema as VehicleCollisionSchema,
  uiSchema as VehicleCollisionuiSchema
} from "wn-claims-shared/dist/schema/vehicle-collision-schema";
import axios from "axios";
import { objectMap, logger, logFormEvent, validateSaId } from "../utils/common";
import config from "../config.json";
import $ from "jquery";

let fileSizeExceeded = false;

class Wizard extends Component {
  constructor(props) {
    super(props);
    this.formData = { ...this.props.formData, ...this.props.selectFormData };

    logger([this.formData]);
    this.state = {
      step: 0,
      formData: this.formData,
      formStage: 0,
      saveTabs: []
    };
    let schema, uiSchema;
    switch (this.formData.claimtype) {
      case "Non-Motor":
        schema = GeyserSchema;
        uiSchema = GeyseruiSchema;
        break;
      case "Motor":
        schema = VehicleCollisionSchema;
        uiSchema = VehicleCollisionSchema;
        break;
      case "Motor Traders Internal":
        schema = VehicleCollisionSchema;
        uiSchema = VehicleCollisionuiSchema;
        break;
      case "Motor Traders External":
        schema = VehicleCollisionSchema;
        uiSchema = VehicleCollisionSchema;
        break;
      case "Motor Unspecified":
        schema = VehicleCollisionSchema;
        uiSchema = VehicleCollisionSchema;
        break;
      default:
        schema = {};
        uiSchema = {};
        break;
    }

    this.schemas = this.props.schemas ? this.props.schemas : [];
    this.uiSchemas = this.props.uiSchemas ? this.props.uiSchemas : [];
    const tp = this.formData?.thirdparty;
    const titlesToRemove = [
      "Third Party",
      "Third Party Vehicle Details",
      "Third Party Injured Persons"
    ];
    if (!tp || tp === "No") {
      // No third party (absent or explicitly declined on FormSelection)
      titlesToRemove.forEach((title) => {
        this.schemas = this.schemas.filter((schema) => schema.title !== title);
        this.uiSchemas = this.uiSchemas.filter((_, index) => this.schemas[index]?.title !== title);
      });
    } else if (typeof tp === "object") {
      // thirdparty is the wizard's detailed object — check inner answered fields
      if (tp.thirdpartyOther?.thirdpartyHaveDetails !== undefined) {
        if (
          (tp.thirdpartyInvolved === "Yes") &
          (tp.thirdpartyOther.thirdpartyHaveDetails == "No")
        ) {
          titlesToRemove.forEach((title) => {
            this.schemas = this.schemas.filter((schema) => schema.title !== title);
            this.uiSchemas = this.uiSchemas.filter(
              (_, index) => this.schemas[index]?.title !== title
            );
          });
        }
      }
    }
    // If tp === "Yes" (string), keep all Third Party schemas as-is

    logger(["this.schemas: ", this.schemas]);
    logger(["this.uiSchemas: ", this.uiSchemas]);
    const sTest = this.props.schemas ? "schemas defined" : "no schemas defined";
    this.readOnly = this.props.readOnly;
    this.btnSubmit = <span />;
    if (this.readOnly) {
      // TODO: duplicate call of objectMap, when not read only it is being called in the wrapping comp, pass info to here from parent and complete mapping here for all components
      objectMap(schema.properties, (value) => {
        this.schemas.push(value);
        this.uiSchemas.push(uiSchema);
      });
    }
    this.attachmentKeys = [
      // FIXME: find a better solution to hard coding attachment keys here (use a config file or flag with a custom type?)
      // Geyser
      "attachmentsList",
      // Group Personal
      "disablementDocCert",
      "disablementPercentageConfirmation",
      "disablementAppointmentLetter",
      "disablementMedReport",
      "disablementMedAccountsStatements",
      "disablementPolicePlan",
      "iodPostMortem",
      "iodInquestReport",
      "iodExecutorshipLetter",
      // Property Loss
      "itemsClaimedDocs",
      // Public Liability
      "claimsAttachment",
      // Vehicle Loss
      // TODO: add vehicle loss attachment keys
      "incidentReport",
      "descriptionSketch"
      // Windscreen
    ];
    logger(["Logger!"]);
    logger(["this.schemas: ", this.schemas]);
    logger(["this.uiSchemas: ", this.uiSchemas]);
  }

  ObjectFieldTemplate({ TitleField, properties, title, description }) {
    return (
      <div className="container">
        <TitleField title={title} />
        <div>{description}</div>
        <div className="row">
          {properties.map((prop) => (
            <div className="col col-sm-6 left" key={prop.content.key}>
              {prop.content}
            </div>
          ))}
        </div>
      </div>
    );
  }
  // TODO: move to utils
  validateTelNumbers = (formData, errors) => {
    const phoneno = /^\d{10}$/;
    // FIXME: is it possible to use a universal telephone type to flag telephone number validations instead of hardcoding? if not move to a config file
    const telephoneKeys = ["contactNumber", "otherPartyIncidentDetails.contactNumber"];
    logger(["formData", formData]);
    logger(["errors", errors]);

    telephoneKeys.forEach((element) => {
      console.log(element);

      var formDataInfo = formData;

      if (typeof formData.otherPartyIncidentDetails != "undefined") {
        if (element == "otherPartyIncidentDetails.contactNumber") {
          formDataInfo = formData.otherPartyIncidentDetails;
          element = "contactNumber";
        }
      }

      if (formDataInfo.hasOwnProperty(element) && formDataInfo[element]) {
        if (!formDataInfo[element].match(phoneno)) {
          //errors[element].addError("Not a valid contact number.");
        }
      }
    });

    // Validate Driver ID/Passport Number (inside driverDetails object of the driverDetails step)
    const driverIdPassport = formData?.driverDetails?.driverIdPassport;
    if (driverIdPassport) {
      const idError = validateSaId(driverIdPassport);
      if (idError) {
        try {
          errors.driverDetails.driverIdPassport.addError(idError);
        } catch (e) { /* nested path may not exist on all form steps */ }
      }
    }

    // Validate ID/Passport Number (top-level field used in non-motor forms)
    const idPassportNumber = formData?.idPassportNumber;
    if (idPassportNumber) {
      const idError = validateSaId(idPassportNumber);
      if (idError) {
        try {
          errors.idPassportNumber.addError(idError);
        } catch (e) { /* field may not exist on all form steps */ }
      }
    }

    // Validate that the police report date is not before the incident date.
    // incidentDateTime is date-time (ISO); policeReportDate is date (YYYY-MM-DD).
    const incidentDateTime = formData?.incident?.insureddateloss;
    const policeReportDate = formData?.police?.reportDetails?.policeDateReported;

    if (incidentDateTime && policeReportDate) {
      const incidentDateOnly = String(incidentDateTime).substring(0, 10); // "YYYY-MM-DD"
      if (policeReportDate < incidentDateOnly) {
        try {
          errors.reportDetails.policeDateReported.addError(
            `Date reported cannot be before the date of the incident (${incidentDateOnly}).`
          );
        } catch (e) { /* dependency field may not be present in errors on all steps */ }
      }
    }

    // Validate that the incident date/time is not in the future.
    if (incidentDateTime) {
      if (new Date(incidentDateTime) > new Date()) {
        try {
          errors.incident.insureddateloss.addError(
            "The incident date and time cannot be in the future."
          );
        } catch (e) { /* field may not be present in errors on all steps */ }
      }
    }

    return errors;
  };

  onSubmit = ({ formData }) => {
    if (this.state.step < this.schemas.length - 1) {
      const newstep = parseInt(this.state.step, 10) + 1;
      logger(["newstep:", newstep]);

      this.setState({
        ...this.state,
        step: newstep,
        formData: {
          ...this.state.formData,
          ...formData
        }
      });
    } else {
      if (!this.readOnly) {
        // Don't post if in readOnly mode
        this.setState({ formStage: 1 });
        this.postForm(formData);
      }
    }
  };
  // TODO: move to utils
  getBase64FileName = (base64str) => {
    let str = base64str;
    str = str.substr(str.indexOf("name=") + 5, str.lastIndexOf("base64,") - 27);
    return str;
  };
  // TODO: move to utils
  getAttachments = (formData) => {
    let attachments = [];
    logger(["getAttachments formData", formData]);
    logger(["getAttachments attachmentKeys", this.attachmentKeys]);
    this.attachmentKeys.forEach(function (key) {
      if (formData[key]) {
        formData[key].forEach(function (entry) {
          logger(["entry: ", entry]);
          const fileName = entry.attachment[0];
          const fileContent = entry.attachment[1][0];
          attachments.push({ name: fileName, content: fileContent });
          /*
          fName = fName.substr(
            fName.indexOf("name=") + 5,
            fName.lastIndexOf("base64,") - 27
          );
          fName = fName.replace(/[^a-zA-Z0-9]/g, "");
          logger(["file name:", fName]);
          logger(["attachment: ", key + ":", fName]);
          attachments = [
            ...attachments,
            {
              name: fName,
              content: entry
            }
          ];
          */
        });
      }
    });
    logger(["generated attachments", attachments]);
    return attachments;
  };

  postForm = (formData) => {
    const hostname = window.location.hostname;
    let url = "";
    for (let host in config.hosts) {
      if (hostname == config.hosts[host].hostname) {
        console.log(`Running on ${host} environment.`);
        url = config.hosts[host].postFormEndpoint;
        console.log("setting Post Form API url to ", url);
      }
    }
    if (!url) {
      // set default url if not set
      console.warn("No valid Post Form API endpoint found in config. Setting to default.");
      url = config.hosts.default.postFormEndpoint;
    }
    console.log("URL", url);
    const concatData = { ...this.state.selectedForm, ...formData };
    const strData = JSON.stringify(concatData, null, 0);
    logger(["formData: ", formData]);
    logger(["concatData: ", concatData]);
    const ct = concatData.claimtype;
    const reg = concatData.region;
    const FormGuid = concatData.formguid;
    logger(["formGuid", FormGuid]);
    let attachments = this.getAttachments(concatData);

    const data = {
      properties: {
        Form: strData,
        FormGUID: FormGuid,
        Claim: ct,
        Insured: concatData.insuredName,
        PolicyNo: concatData.insuredPolicyNumber,
        Region: reg,
        requestorType: concatData.requestorType,
        ClientEmail: concatData.clientEmail,
        BrokerEmail: concatData.brokeremail,
        Attachments: attachments
      }
    };
    logger(["Data: ", concatData]);
    logger(["Post: ", data]);
    logger(["Post str: ", JSON.stringify(data)]);
    axios
      .post(url, data)
      .then((response) => {
        logger(["Done: ", response]);
        this.setState({ selectedForm: {}, formStage: 2 }); // FIXME: not resetting state, keep ref of initial state instead
      })
      .catch((error) => {
        logger(["Error: ", error]);
        let code = error["response"]["status"];
        let message;
        switch (code) {
          case 503:
            // request timed out
            code = "Error (503): Request Timed Out";
            message = "The service is currently not available. Please try again later.";
            break;
          default:
            // other errors
            code = `Error (${code})`;
            message = error["response"]["data"]["error"]["message"];
        }
        logger(["code: ", code, " message: ", message]);
        // this.setState({
        //   formErrCode: code,
        //   formErrMsg: message
        // });
        this.setState({
          selectedForm: {},
          formStage: 3
        });
      });
  };

  onBack = ({ formData }) => {
    if (this.state.step > 0) {
      const newstep = this.state.step - 1;
      logger(["newstep:", newstep]);
      this.setState({
        ...this.state,
        step: newstep,
        formData: {
          ...this.state.formData,
          ...formData
        }
      });
    }
  };

  onStep = (step) => {
    if (step < this.state.step) {
      const newstep = step;
      logger(["tabstep:", newstep]);
      this.setState({
        step: newstep
      });
      logger(["new step-tab: ", this.state.step]);
    }
  };

  handleTabClick = (k) => {
    if (fileSizeExceeded) {
      return;
    }
    // Get clicked tab step number
    const step = k;
    // cancel if the clicked step is after current step,
    // ignore this rule in read-only mode
    if (!this.readOnly && k > this.state.step) return;
    logger(["goto step: ", k]);
    // change state step (triggers loading clicked tab)
    this.setState({
      ...this.state,
      step: step,
      formData: {
        ...this.state.formData
      }
    });
  };

  checkDuplicateAttachments = (attachments) => {
    if (!attachments) return;
    logger(["attachments", attachments]);

    let files = $("#root_attachmentsList ul.file-info li");
    //Check if file exists

    for (let i = 0; i < files.length; i++) {
      let item = files[i];
      let file = item.textContent;
      let split = file.split(",");
      let fileSize = split[1].replace(" bytes)", "");
      fileSize = fileSize.trim();
      if (fileSize > 20000000) {
        alert("File upload size limit is 20mb");
        fileSizeExceeded = true;
      } else {
        fileSizeExceeded = false;
      }
    }

    if (fileSizeExceeded) {
      $("#btnNext").attr("disabled", "disabled");
      $("#btnBack").attr("disabled", "disabled");
    } else {
      $("#btnNext").removeAttr("disabled");
      $("#btnBack").removeAttr("disabled");
    }

    let occurrences = {};

    let filtered = attachments.filter(function (x, index) {
      logger(["x name", x.attachment[0]]);
      if (occurrences[x.attachment[0]]) {
        x.attachment[0] = x.attachment[0] ? `${x.attachment[0]} (${index})` : `${index}`;
        return false;
      }
      occurrences[x.attachment[0]] = true;
      return true;
    });

    logger(["filtered", filtered]);
  };

  handleChanges = (data) => {
    logger(["changes data: ", data]);
    const {
      claimtype,
      attachmentsList,
      descriptionSketch,
      incidentReport,
      claimsAttachment,
      itemsClaimedDocs
    } = data.formData;

    if (attachmentsList) this.checkDuplicateAttachments(attachmentsList);
    if (descriptionSketch) this.checkDuplicateAttachments(descriptionSketch);
    if (incidentReport) this.checkDuplicateAttachments(incidentReport);
    if (claimsAttachment) this.checkDuplicateAttachments(claimsAttachment);
    if (itemsClaimedDocs) this.checkDuplicateAttachments(itemsClaimedDocs);

    // Check for the incidentAddress
    if (typeof data.formData.incidentAddress != "undefined") {
      if (
        typeof document.getElementById("root_incidentAddress") != "undefined" &&
        document.getElementById("root_incidentAddress") != null
      ) {
        if (
          document.getElementById("root_incidentAddress").value != data.formData.incidentAddress
        ) {
          data.formData.incidentAddress = document.getElementById("root_incidentAddress").value;
          data.formData.incidentLat = document.getElementById("root_incidentLat").value;
          data.formData.incidentLong = document.getElementById("root_incidentLong").value;
          logger(["Updated Address: ", data]);
        }
      }
    } else {
      //logger('OOps no Incident Address')
    }

    // Check for the currentVehicleLocation
    if (typeof data.formData.currentVehicleLocation != "undefined") {
      if (
        typeof document.getElementById("root_currentVehicleLocation_address") != "undefined" &&
        document.getElementById("root_currentVehicleLocation_address") != null
      ) {
        if (
          document.getElementById("root_currentVehicleLocation_address").value !=
          data.formData.currentVehicleLocation
        ) {
          data.formData.currentVehicleLocation.address = document.getElementById(
            "root_currentVehicleLocation_address"
          ).value;
          data.formData.currentVehicleLocation.lat = document.getElementById(
            "root_currentVehicleLocation_lat"
          ).value;
          data.formData.currentVehicleLocation.long = document.getElementById(
            "root_currentVehicleLocation_long"
          ).value;
          logger(["Updated Address: ", data]);
        }
      }
    } else {
      //logger('OOps no Vehicle Current Address')
    }

    // Check for the otherPartyIncidentDetails
    if (typeof data.formData.otherPartyIncidentDetails != "undefined") {
      if (
        typeof document.getElementById("root_otherPartyIncidentDetails_address") != "undefined" &&
        document.getElementById("root_otherPartyIncidentDetails_address") != null
      ) {
        if (
          document.getElementById("root_otherPartyIncidentDetails_address").value !=
          data.formData.otherPartyIncidentDetails
        ) {
          data.formData.otherPartyIncidentDetails.address = document.getElementById(
            "root_otherPartyIncidentDetails_address"
          ).value;
          data.formData.otherPartyIncidentDetails.lat = document.getElementById(
            "root_otherPartyIncidentDetails_lat"
          ).value;
          data.formData.otherPartyIncidentDetails.long = document.getElementById(
            "root_otherPartyIncidentDetails_long"
          ).value;
          logger(["Updated Address: ", data]);
        }
      }
    } else {
      //logger('OOps no Other Party Address')
    }

    // Check for the propertyDamageAddress
    if (typeof data.formData.propertyDamageAddress != "undefined") {
      if (
        typeof document.getElementById("root_propertyDamageAddress_address") != "undefined" &&
        document.getElementById("root_propertyDamageAddress_address") != null
      ) {
        if (
          document.getElementById("root_propertyDamageAddress_address").value !=
          data.formData.propertyDamageAddress
        ) {
          data.formData.propertyDamageAddress.address = document.getElementById(
            "root_propertyDamageAddress_address"
          ).value;
          data.formData.propertyDamageAddress.lat = document.getElementById(
            "root_propertyDamageAddress_lat"
          ).value;
          data.formData.propertyDamageAddress.long = document.getElementById(
            "root_propertyDamageAddress_long"
          ).value;
          logger(["Updated Address: ", data]);
        }
      }
    } else {
      //logger('OOps no Property Damage Address')
    }

    logger(["claim type: ", claimtype]);
    const saveTabs = this.state.saveTabs;
    if (claimtype === "Accident Collision" && this.formData.thirdparty.thirdpartyInvolved == "No") {
      logger(["schemas pre slice: ", this.schemas]);

      if (this.schemas[6].title === "Third Party") {
        saveTabs.push(this.schemas[6]);
        saveTabs.push(this.schemas[7]);
        saveTabs.push(this.schemas[8]);
        this.schemas.splice(6, 3); // splice Third party tabs
        this.setState({
          ...this.state,
          saveTabs: saveTabs,
          formData: {
            ...this.state.formData
          }
        });
      }
      logger(["schemas post slice: ", this.schemas]);
      logger(["saved tabs", saveTabs]);
    } else if (
      claimtype === "Accident Collision" &&
      this.formData.thirdparty.thirdpartyInvolved == "Yes" &&
      this.formData.thirdparty.thirdpartyOther.thirdpartyHaveDetails == "No"
    ) {
      logger(["schemas pre slice: ", this.schemas]);

      if (this.schemas[6].title === "Third Party") {
        saveTabs.push(this.schemas[6]);
        saveTabs.push(this.schemas[7]);
        this.schemas.splice(6, 2); // splice Third party tabs
        this.setState({
          ...this.state,
          saveTabs: saveTabs,
          formData: {
            ...this.state.formData
          }
        });
      }
      logger(["schemas post slice: ", this.schemas]);
      logger(["saved tabs", saveTabs]);
    }

    const claimMotorCauseOfLoss = data.formData.claimMotorCauseOfLoss || "";
    const causedBy = data.formData.CausedBy || "";
    if (
      (claimMotorCauseOfLoss === "Vehicle - Theft" && causedBy === "Vehicle - Hijack") ||
      (claimMotorCauseOfLoss === "Vehicle - Theft" && causedBy === "Vehicle-Theft") ||
      (claimMotorCauseOfLoss === "Vehicle - Glass" && causedBy === "Replace")
    ) {
      // Safely remove the `incidentDriverDrugTest` property if it exists
      try {
        $("#root_incidentDriverDrugTest").removeAttr("required");
        $("#root_incidentDriverDrugTest").parent().attr("hidden", true);
        $("#root_incidentCoverInfo_incidentCover").removeAttr("required");
        $("#root_incidentCoverInfo_incidentCover").parent().attr("hidden", true);
        $("#root_incidentVehicleStatusInfo_incidentVehicleStatus").removeAttr("required");
        $("#root_incidentVehicleStatusInfo_incidentVehicleStatus").parent().attr("hidden", true);
        $("#root_incidentVehicleStatusInfo_incidentVehicleLocation")
          .parent()
          .removeAttr("required");
        $("#root_incidentVehicleStatusInfo_incidentVehicleLocation").parent().attr("hidden", true);
        $("#root_thirdparty_thirdpartyOther_thirdpartyHaveDetailsNote")
          .parent()
          .attr("hidden", true);
      } catch (error) {
        console.log("Error removing required attributes: ", error);
      }
    }

    console.log("See Full FormData: ", data.formData);
  };

  navHome() {
    return (window.location.href = "/");
  }

  navHomeReadOnly() {
    return (window.location.href = "/sites/workbenchqa/SiteAssets/ClaimsList.aspx/");
  }

  render() {
    const { formStage, step } = this.state;

    let back, next;
    if (!this.readOnly) {
      // Normal view buttons
      if (step > 0) {
        back = (
          <button id="btnBack" className="btn btn-primary" type="button" onClick={this.onBack}>
            Back
          </button>
        );
        next = (
          <button
            id="btnNext"
            className="btn btn-primary"
            type="submit"
            style={{ boxShadow: "none !important" }}
          >
            {" "}
            {step < this.schemas.length - 1 ? "Next" : "Submit"}
          </button>
        );
      } else {
        back = (
          <button
            id="btnBack"
            className="btn btn-primary"
            type="button"
            onClick={() => {
              if (typeof this.props.onBack === "function") {
                this.props.onBack();
              } else {
                window.location.href = "/";
              }
            }}
          >
            Back
          </button>
        );
        next = (
          <button
            id="btnNext"
            className="btn btn-primary"
            type="submit"
            style={{ boxShadow: "none !important" }}
          >
            {" "}
            {step < this.schemas.length - 1 ? "Next" : "Submit"}
          </button>
        );
      }
    } else {
      // Set read-only buttons
      back = (
        <button
          className="btn btn-primary"
          type="button"
          onClick={!this.readOnly ? this.navHome : this.navHomeReadOnly}
        >
          Close
        </button>
      );
      next = "";
    }

    let readOnlyHeader;
    if (this.readOnly) {
      readOnlyHeader = (
        <div>
          <h3>{this.formData.claimtype}</h3>
          <p>
            {"Policy Number: " + this.formData.insuredPolicyNumber}
            <br />
            {"Insured Name: " + this.formData.insuredName}
            <br />
            {"Region: " + this.formData.region}
          </p>
        </div>
      );
    }

    let form, tabs;
    if (this.state.formErrCode) {
      // Form threw error
      // form = (
      //   <div style={{ margin: "2em" }}>
      //     {this.state.formErrCode ? <h4>{this.state.formErrCode}</h4> : ""}
      //     {this.state.formErrMsg ? <div>{this.state.formErrMsg}</div> : ""}
      //   </div>
      // );
      //FIXME: Error moved to formStage=3
    } else {
      // No error
      if (formStage == 0) {
        // Compute uiSchema for this step, injecting a "max" on insureddateloss
        // so the browser datetime picker does not allow future date/times.
        const currentStepSchema = this.schemas[this.state.step];
        const currentStepUiSchema = this.uiSchemas[this.state.step] || {};
        let stepUiSchema = currentStepUiSchema;
        if (currentStepSchema?.properties?.insureddateloss) {
          const now = new Date();
          const pad = (n) => String(n).padStart(2, '0');
          const maxDateTime = `${now.getFullYear()}-${pad(now.getMonth() + 1)}-${pad(now.getDate())}T${pad(now.getHours())}:${pad(now.getMinutes())}`;
          stepUiSchema = {
            ...currentStepUiSchema,
            insureddateloss: {
              ...(currentStepUiSchema.insureddateloss || {}),
              "ui:options": {
                ...((currentStepUiSchema.insureddateloss || {})["ui:options"] || {}),
                "inputProps": {
                  ...(((currentStepUiSchema.insureddateloss || {})["ui:options"] || {})["inputProps"] || {}),
                  "max": maxDateTime
                }
              }
            }
          };
        }
        form = (
          <div style={{ margin: "2em" }}>
            <Form
              schema={this.schemas[this.state.step]}
              uiSchema={stepUiSchema}
              onSubmit={this.onSubmit}
              formData={this.state.formData}
              onChange={this.handleChanges}
              onError={logFormEvent("errors")}
              showErrorList={false}
              disabled={this.readOnly}
              validate={this.validateTelNumbers}
            >
              <div style={{ margin: "2em" }}>
                {back}
                {/* //FIXME: remove inline styling */}
                {next}
              </div>
            </Form>
          </div>
        );
        tabs = Object.keys(this.schemas).map((tab) => (
          <div
            className={"nav-item active key-" + tab}
            key={"nav-item" + tab}
            onClick={() => this.handleTabClick(tab)}
            disabled={!this.readOnly ? (tab < this.state.step ? false : true) : false}
            style={{ cursor: "pointer" }}
          >
            <div
              className={
                "nav-link " +
                (tab == this.state.step ? " active show" : "") +
                (tab > this.state.step ? " disabled" : "") +
                (tab < this.state.step ? " completed" : "")
              }
            >
              {this.schemas[tab].title}
            </div>
          </div>
        ));
      } else if (formStage == 1) {
        // Posting form
        form = (
          <div style={{ margin: "2em" }}>
            <h3>Please Wait</h3>
            <div>Submitting claim..</div>
          </div>
        );
      } else if (formStage == 2) {
        // Successfully posted form
        // TODO: use ThankYou shared component instead
        form = (
          <div style={{ margin: "2em" }}>
            <h3>Thank you for submitting your claim</h3>
            Your broker will be informed within the next 24 hours of claim number and will be
            provided with the next steps in the claim process.
            <br />
            <br />
            <button
              className="btn btn-primary"
              onClick={!this.readOnly ? this.navHome : this.navHomeReadOnly}
            >
              Finish
            </button>
          </div>
        );
      } else if (formStage == 3) {
        // Error posting form
        form = (
          <div style={{ margin: "2em" }}>
            <h3>Oops, something has gone wrong while trying to submit your claim</h3>
            Please try again. Click on the button below, update the declaration and resubmit. <br />
            All the rest of your claims detail has been stored and don’t have to be recaptured.
            <br />
            <br />
            <button
              className="btn btn-primary"
              onClick={() => {
                this.setState({ selectedForm: {}, formStage: 0 });
              }}
            >
              Back to Form
            </button>
          </div>
        );
      }
    }

    return (
      <div>
        {readOnlyHeader}
        <br />
        <div className="card shadow">
          {tabs ? (
            <div className="nav nav-tabs card-header" style={{ padding: 0 }}>
              {tabs}
            </div>
          ) : null}
          {form}
        </div>
      </div>
    );
  }
}

export default Wizard;
